<template>
  <b-modal size="xl" scrollable content-class="helpModal" v-model="isShow">
    <template #modal-title>
      {{ $t('Help') }}
    </template>
    <b-container fluid>
      <div class="help">
        <b-row class="mb-1 text-center">
          <b-col>
            <b-button
              @click="setPage('iFKit_Set')"
              variant="outline-secondary"
              :disabled="page === 'iFKit_Set'"
            >
              1. iFKit 설정
            </b-button>
          </b-col>
          <b-col>
            <b-button
              @click="setPage('iFLine_Set')"
              variant="outline-secondary"
              :disabled="page === 'iFLine_Set'"
            >
              2. iFLine 설정
            </b-button>
          </b-col>
        </b-row>
        <div class="contentPage" v-show="page === 'iFKit_Set'">
          <h4>1. iFKit 설정</h4>
          <b-card title="1.1 AP 모드 설정">
            <b-card-text>
              a. <span class="strong">0버튼을 5초이상</span>(6~7초) 누르면 WIFI
              설정이 초기화 된다.<br />
              b. 재부팅하고 AP 모드로 전환된다.<br />
              <span class="contentList">
                - 참고 : AP 모드는 Access Point의 약자로 장비가 와이파이
                공유기로 동작하는 상태이다.<br /><br />
                - 참고 : 디바이스 상태<br />
                - 와이파이 접속중 : 4번 LED가 0.3초 주기로 깜빡인다.<br />
                - AP 모드 : 4번 LED가 2초동안 켜지고, 0.5초 주기로 2번 깜빡이고,
                2초동안 꺼진다.<br />
                - 프로그램 오류 : 4번 LED가 1초 주기로 깜빡인다.<br />
              </span>
            </b-card-text>
          </b-card>
          <iframe
            width="725"
            height="408"
            src="https://www.youtube.com/embed/FBMMihzCWS8"
            title="YouTube video player"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen
          >
          </iframe>
          <b-card title="1.2 설정 웹페이지">
            <b-card-text>
              a. 노트북, 스마트폰, 패드 등에서 와이파이 검색창을 연다.<br />
              b. 네트워크 ID <span class="strong">iFKit_xxxxx</span>을
              연결한다.<br />
              c. 웹브라우저를 열고 주소줄에 "<span class="strong"
                >192.168.4.1</span
              >"을 입력한다.<br />
              d. 사무실 또는 집에서 사용하는 와이파이 공유기의 "<span
                class="strong"
                >네트워크 ID</span
              >"와 "<span class="strong">네트워크 비밀번호</span>"를 입력한다.
              <span class="contentList"
                >와이파이는 2.4GHz에 연결이 가능하고 5Ghz에는 연결되지
                않는다.</span
              ><br />
              e. iFBlock(ifblock.web.app)에 가입한
              <span class="strong">이메일</span>을 입력한다.<br />
              e. (선택) 장비의 SSID를 수정할 수 있다. 이후에 접속할 때 b의
              "네트워크 ID"에 수정한 ID로 표시된다.<br />
              f. "<span class="strong">저장 후 재부팅</span>" 버튼을 누른다.<br />
              <span class="contentList">
                - 참고 : 재부팅되면 와이파이 연결을 자동으로 시도한다. 연결이
                되었다면 1.3 와이파이 연결은 건너뛰어도 된다.<br />
              </span>
            </b-card-text>
          </b-card>
          <iframe
            width="725"
            height="408"
            src="https://www.youtube.com/embed/wEKyZfTgdf4"
            title="YouTube video player"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen
          >
          </iframe>
          <b-card title="1.3 와이파이 연결">
            <b-card-text>
              a. (선택) <span class="strong">리셋버튼을 눌러</span> 장비를
              재부팅한다.<br />
              b. 부팅후 접속정보가 설정되어 있으면 와이파이 접속중 상태(1.1
              참고)가 표시된다.<br />
              c. 와이파이가 접속되면 4번 LED가 꺼진다.<br />
              <span class="contentList">
                - 참고 : 와이파이 접속중 상태가 계속되면 와이파이 설정이
                잘못되었을 수 있으므로 1.1 부터 다시 진행한다.<br />
              </span>
            </b-card-text>
          </b-card>
          <iframe
            width="725"
            height="408"
            src="https://www.youtube.com/embed/4Br_nm9KnKM"
            title="YouTube video player"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen
          >
          </iframe>
          <b-card title="1.4 프로그램 배포">
            <b-card-text>
              a. iFBlock(ifblock.web.app)에
              <span class="strong">로그인</span>한다. (설정 > 로그인)<br />
              b. "<span class="strong">배포 버튼</span>"을 누른다.<br />
              c. "<span class="strong">장치연결 버튼</span>" ("연결 끊김",
              "장치" 다음에 있는 버튼)을 눌르면 "장치 연결" 팝업창이
              나타난다.<br />
              d. "장치 연결" 팝업창에서 장치 목록에서 연결하려는
              <span class="strong">장치</span>를 눌러 선택한다.<br />
              e. 연결버튼을 누르면 잠시후에 "iFBlock 접속을 환영합니다!"가
              표시된다<br />
              f. "<span class="strong">프로그램 전송</span>" 버튼을 누르면
              장치가 재부팅된다.<br />
              g. 장치가 재부팅된 후에 프로그램이 실행된다.<br />
              <span class="contentList">
                - 참고 : 이후 "배포 버튼"을 누르면 기존에 연결되었던 장치에
                자동으로 연결되어 "프로그램 전송 버튼"만 누르면 된다.<br /><br />
                - 문제 : "장치 연결" 팝업창의 장치 목록에 연결하려는 장치가
                없다면 1.2 설정에서 다른 이메일을 입력하여 나오는 현상으로
                1.1부터 다시 진행한다.<br />
              </span>
            </b-card-text>
          </b-card>
          <iframe
            width="725"
            height="408"
            src="https://www.youtube.com/embed/SEN_n2guCZg"
            title="YouTube video player"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen
          >
          </iframe>
        </div>
        <div class="contentPage" v-show="page === 'iFLine_Set'">
          <h4>2. iFLine 설정</h4>
          <b-card title="2.1 AP 모드 설정">
            <b-card-text>
              a. <span class="strong">0버튼을 5초이상</span>(6~7초) 누르면 WIFI
              설정이 초기화 된다.<br />
              b. 재부팅하고 AP 모드로 전환된다.<br />
              <span class="contentList">
                - 참고 : AP 모드는 Access Point의 약자로 장비가 와이파이
                공유기로 동작하는 상태이다.<br /><br />
                - 참고 : 디바이스 상태<br />
                - 와이파이 접속중 : iFLine 4개의 LED가 녹색으로 켜진다.<br />
                - AP 모드 : iFLine 4개의 LED가 파란색으로 켜진다.<br />
                - 프로그램 오류 : iFLine 4개의 LED가 빨간색으로 켜진다.<br />
              </span>
            </b-card-text>
          </b-card>
          <iframe
            width="725"
            height="408"
            src="https://www.youtube.com/embed/k18FY1cAvaU"
            title="YouTube video player"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen
          >
          </iframe>
          <b-card title="2.2 설정 웹페이지">
            <b-card-text>
              a. 노트북, 스마트폰, 패드 등에서 와이파이 검색창을 연다.<br />
              b. 네트워크 ID <span class="strong">iFLine_xxxxx</span>을
              연결한다.<br />
              c. 웹브라우저를 열고 주소줄에 "<span class="strong"
                >192.168.4.1</span
              >"을 입력한다.<br />
              d. 사무실 또는 집에서 사용하는 와이파이 공유기의 "<span
                class="strong"
                >네트워크 ID</span
              >"와 "<span class="strong">네트워크 비밀번호</span>"를 입력한다.
              <span class="contentList"
                >와이파이는 2.4GHz에 연결이 가능하고 5Ghz에는 연결되지
                않는다.</span
              ><br />
              e. iFBlock(ifblock.web.app)에 가입한
              <span class="strong">이메일</span>을 입력한다.<br />
              e. (선택) 장비의 SSID를 수정할 수 있다. 이후에 접속할 때 b의
              "네트워크 ID"에 수정한 ID로 표시된다.<br />
              f. "<span class="strong">저장 후 재부팅</span>" 버튼을 누른다.<br />
              <span class="contentList">
                - 참고 : 재부팅되면 와이파이 연결을 자동으로 시도한다. 연결이
                되었다면 1.3 와이파이 연결은 건너뛰어도 된다.<br />
              </span>
            </b-card-text>
          </b-card>
          <iframe
            width="725"
            height="408"
            src="https://www.youtube.com/embed/Um5qx4WpZy4"
            title="YouTube video player"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen
          >
          </iframe>
          <b-card title="2.3 와이파이 연결">
            <b-card-text>
              a. (선택) <span class="strong">리셋버튼을 눌러</span> 장비를
              재부팅한다.<br />
              b. 부팅후 접속정보가 설정되어 있으면 와이파이 접속중 상태(2.1
              참고)가 표시된다.<br />
              c. 와이파이가 접속되면 iFLine 4개의 LED가 꺼진다.<br />
              <span class="contentList">
                - 참고 : 와이파이 접속중 상태가 계속되면 와이파이 설정이
                잘못되었을 수 있으므로 2.1 부터 다시 진행한다.<br />
              </span>
            </b-card-text>
          </b-card>
          <iframe
            width="725"
            height="408"
            src="https://www.youtube.com/embed/QI-wWbWTub0"
            title="YouTube video player"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen
          >
          </iframe>
          <b-card title="2.4 프로그램 배포">
            <b-card-text>
              a. iFBlock(ifblock.web.app)에
              <span class="strong">로그인</span>한다. (설정 > 로그인)<br />
              b. "<span class="strong">배포 버튼</span>"을 누른다.<br />
              c. "<span class="strong">장치연결 버튼</span>" ("연결 끊김",
              "장치" 다음에 있는 버튼)을 눌르면 "장치 연결" 팝업창이
              나타난다.<br />
              d. "장치 연결" 팝업창에서 장치 목록에서 연결하려는
              <span class="strong">장치</span>를 눌러 선택한다.<br />
              e. 연결버튼을 누르면 잠시후에 "iFBlock 접속을 환영합니다!"가
              표시된다<br />
              f. "<span class="strong">프로그램 전송</span>" 버튼을 누르면
              장치가 재부팅된다.<br />
              g. 장치가 재부팅된 후에 프로그램이 실행된다.<br />
              <span class="contentList">
                - 참고 : 이후 "배포 버튼"을 누르면 기존에 연결되었던 장치에
                자동으로 연결되어 "프로그램 전송 버튼"만 누르면 된다.<br /><br />
                - 문제 : "장치 연결" 팝업창의 장치 목록에 연결하려는 장치가
                없다면 2.2 설정에서 다른 이메일을 입력하여 나오는 현상으로
                2.1부터 다시 진행한다.<br />
              </span>
            </b-card-text>
          </b-card>
          <iframe
            width="725"
            height="408"
            src="https://www.youtube.com/embed/1_JneDuDsAc"
            title="YouTube video player"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen
          >
          </iframe>
        </div>
      </div>
    </b-container>
    <template #modal-footer="{ ok }">
      <div class="float-right">
        <b-button size="sm" @click="ok">
          {{ $t('Close') }}
        </b-button>
      </div>
    </template>
  </b-modal>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'HelpPopup',
  data() {
    return {
      isShow: false,
      page: 'iFKit_Set'
    }
  },
  computed: {
    ...mapState(['language', 'helpPopupData'])
  },
  methods: {
    setPage(page) {
      this.page = page
    }
  },
  watch: {
    helpPopupData() {
      if (this.helpPopupData.isShow) {
        this.isShow = true
      } else {
        this.isShow = false
      }
    }
  }
}
</script>

<style>
.help .btn-outline-secondary.disabled,
.help .btn-outline-secondary:disabled {
  color: #fff;
  background-color: #2e5c85;
  border-color: #2f5e86;
}

.help .card {
  max-width: 100%;
  display: inline-block;
  width: 315px;
  margin-right: 17px;
  vertical-align: top;
}

.help .card:not(:first-of-type) {
  margin-top: 15px;
}

.help .card-title {
  font-size: 18px;
  line-height: 26px;
  color: rgb(52, 52, 252);
}

.help .contentList {
  font-size: 14px;
  color: #00891f;
}

.help .strong {
  font-weight: 700;
  color: #eb2c01;
}

.help iframe {
  max-width: 100%;
  vertical-align: top;
  display: inline-block;
}

.help iframe:not(:first-of-type) {
  margin-top: 15px;
}

@media only screen and (max-width: 600px) {
  .helpModal .modal-body {
    padding: 1rem 0;
  }

  .helpModal .container-fluid {
    padding-left: 3px;
    padding-right: 3px;
  }
}

@media only screen and (max-width: 1199px) {
  .help .card {
    width: unset;
    margin-right: 0;
  }

  .help iframe {
    margin-top: 15px;
  }

  .modal-xl {
    max-width: 96%;
  }
}
</style>
